<div class="container-fluid p-0">
  <div class="d-flex flex-column flex-lg-row">
    <div class="col col-lg-8 border-right pe-0 pe-lg-8">
      <div class="mb-5">
        <!--Contract-->
        <div class="row py-2 mb-3 contract-info d-flex align-items-center">
          <div class="col-5">
            <span class="fw-bold">{{ 'contract' | translate }}</span>
          </div>
          <div class="col">
            <div class="d-flex align-items-center gap-3">
              <span>{{ 'from_' | translate }}{{ validContract?.createdAt | baseFormatDate }}</span>
              <base-button
                color="primary"
                [label]="'externalEmployees.viewContract'"
                [size]="buttonSize.xs"
                (click)="viewContract()"
              ></base-button>
            </div>
          </div>
        </div>
        <!--Contract-->

        <!--Signature information-->
        <div class="row py-2 mb-3 contract-info d-flex">
          <div class="col-5">
            <span class="fw-medium">{{ 'externalEmployees.contractSignature' | translate }}</span>
          </div>
          <div class="col">
            <div class="d-flex align-items-baseline mb-1">
              <i
                class="fa-fw fa-solid headline-20 me-3"
                [ngClass]="
                  validContract?.signatures.statusPsp === signatureStatus.SIGNED
                    ? 'fa-check text-success'
                    : 'fa-xmark text-danger'
                "
              ></i>
              <span [innerHTML]="partnerSignatureStatus | translate: partnerSignatureStatusParams"></span>
            </div>
            <div class="d-flex align-items-baseline">
              <i
                class="fa-fw fa-solid me-3"
                [ngClass]="{
                  'fa-check text-success headline-20':
                    validContract?.signatures.statusCustomer === signatureStatus.SIGNED,
                  'fa-hourglass-clock': validContract?.signatures.statusCustomer === signatureStatus.IN_QUEUE,
                  'fa-xmark text-danger headline-20':
                    validContract?.signatures.statusCustomer === signatureStatus.UNSIGNED ||
                    validContract?.signatures.statusCustomer === signatureStatus.ERROR
                }"
              ></i>
              <div class="d-flex flex-column gap-2">
                <span [innerHTML]="ownSignatureStatus | translate: ownSignatureStatusParams"></span>
                <base-button
                  *ngIf="
                    validContract?.signatures.statusCustomer === signatureStatus.UNSIGNED ||
                    validContract?.signatures.statusCustomer === signatureStatus.ERROR
                  "
                  color="primary"
                  [label]="'externalEmployees.signContractNow'"
                  [size]="buttonSize.xs"
                  (click)="onSignContractClick($event)"
                ></base-button>
                <base-button
                  *ngIf="validContract?.signatures.statusCustomer === signatureStatus.IN_QUEUE"
                  color="primary"
                  [label]="'externalEmployees.checkSignatureStatus'"
                  [size]="buttonSize.xs"
                  (click)="reloadAssignment(assignment.id)"
                ></base-button>
              </div>
            </div>
          </div>
        </div>
        <!--Signature information-->

        <!--Assignment dates-->
        <div class="row py-2 mb-3">
          <div class="col-5">
            <span class="fw-bold">{{ 'inquiry.period' | translate }}</span>
          </div>
          <div class="col">
            <p class="mb-2">
              {{ assignment?.startDate | baseFormatDate }} -
              {{ assignment?.endDate ? (assignment.endDate | baseFormatDate) : ('unlimited' | translate) }}
            </p>
            <p
              *ngIf="assignment?.assignmentCancelation?.cancelationDate"
              class="text-danger"
            >
              {{ 'operations.cancelledOn' | translate }}
              {{ assignment.assignmentCancelation.cancelationDate | baseFormatDate }}
            </p>
            <base-button
              *ngIf="!assignment?.assignmentCancelation?.cancelationDate"
              color="secondary"
              [label]="'externalEmployees.unsubscribe'"
              [size]="buttonSize.xs"
              (click)="onDeregisterEmployeeClick()"
            ></base-button>
          </div>
        </div>
        <!--Assignment dates-->

        <!--Qualifications-->
        <div class="row py-2 mb-3">
          <div class="col-5">
            <span class="fw-medium">{{ 'qualifications.singular' | translate }}</span>
          </div>
          <div class="col d-flex flex-column">
            <span class="main-qualification-text"
              >{{ assignment?.mainQualification?.name }} {{ 'primary' | translate }}</span
            >
            <!--Qualifications are not a part of response here-->
            <!--TODO: Uncomment after added to response-->
            <!--<span-->
            <!--  class="text-dark-gray"-->
            <!--  *ngFor="let qualification of assignment?.qualifications"-->
            <!--  >{{ qualification.name }}</span-->
            <!-- >-->
          </div>
        </div>
        <!--Qualifications-->

        <!--Job description-->
        <div class="row py-2 mb-3">
          <div class="col-5">
            <span class="fw-medium">{{ 'jobDescription' | translate }}</span>
          </div>
          <div class="col">
            <span>{{ assignment?.jobDescription | baseIsEmpty }}</span>
          </div>
        </div>
        <!--Job description-->

        <!--Cost unit-->
        <div class="row py-2 mb-3">
          <div class="col-5">
            <span class="fw-medium">{{ 'costUnit' | translate }}</span>
          </div>
          <div class="col">
            <span>{{ assignment?.costUnit | baseIsEmpty }}</span>
          </div>
        </div>
        <!--Cost unit-->

        <!--Work equipment customer-->
        <div class="row py-2 mb-3">
          <div class="col-5 d-flex flex-column">
            <span class="fw-medium">{{ 'workEquipment' | translate }}</span>
            <span class="fs-8">{{ 'providedByUs' | translate }}</span>
          </div>
          <div class="col">
            <span class="text-justify">{{ assignment?.workEquipmentCustomer | baseIsEmpty }}</span>
          </div>
        </div>
        <!--Work equipment customer-->

        <!--Work equipment psp-->
        <div class="row py-2 mb-3">
          <div class="col-5 d-flex flex-column">
            <span class="fw-medium">{{ 'workEquipment' | translate }}</span>
            <span class="fs-8">{{ 'providedByServiceProvider' | translate }}</span>
          </div>
          <div class="col">
            <span class="text-justify">{{ assignment?.workEquipmentPsp | baseIsEmpty }}</span>
          </div>
        </div>
        <!--Work equipment psp-->

        <!--Requirements-->
        <div class="row py-2 mb-3">
          <div class="col-5">
            <span class="fw-medium">{{ 'work.conditions.alt' | translate }}</span>
          </div>
          <div class="col">
            <div
              class="d-flex align-items-center"
              *ngFor="let assignment of assignment?.requirements || []"
            >
              <i class="headline-20 fa-solid fa-check me-3"></i>
              <span>{{ assignment?.name | baseIsEmpty }}</span>
            </div>
          </div>
        </div>
        <!--Requirements-->

        <!--Hourly rate-->
        <div class="row py-2 mb-3">
          <div class="col-5">
            <span class="fw-medium">{{ 'work.conditions.rate' | translate }}</span>
          </div>
          <div class="col">
            <span
              >{{ assignment?.hourlyRate | baseFormatPrice | baseIsEmpty }}
              <span *ngIf="assignment?.hourlyRate">€</span></span
            >
          </div>
        </div>
        <!--Hourly rate-->

        <!--Cancellation period-->
        <div class="row py-2 mb-3">
          <div class="col-5">
            <span class="fw-medium">{{ 'surcharges.cancellationPeriod' | translate }}</span>
          </div>
          <div class="col">
            <span>{{ assignment?.cancellationPeriod | baseHoursToDays | baseIsEmpty }}</span>
          </div>
        </div>
        <!--Cancellation period-->

        <!--Remark to inquiry-->
        <div class="row py-2 mb-3">
          <div class="col-5">
            <span class="fw-medium">{{ 'inquiry.inquiryRemark' | translate }}</span>
          </div>
          <div class="col">
            <span>{{ assignment?.remark | baseIsEmpty }}</span>
          </div>
        </div>
        <!--Remark to inquiry-->
      </div>

      <base-expansion-panel
        *ngIf="assignment?.industrySurcharges"
        title="industrySurcharges.plural"
      >
        <base-industry-surcharges [surcharges]="assignment.industrySurcharges!"></base-industry-surcharges>
      </base-expansion-panel>

      <h2 class="headline-20 my-4">{{ 'surcharges.plural' | translate }}</h2>
      <base-surcharges
        *ngIf="assignment"
        [surcharges]="assignment.surcharges || []"
      ></base-surcharges>
    </div>
    <div class="col col-lg-4 location-info ps-0 ps-lg-4 pe-0">
      <div class="mb-6">
        <h2 class="headline-24 mb-4">{{ 'operations.assignmentLocation' | translate }}</h2>
        <p class="fw-medium m-0">{{ assignment.customerLocation.name }}</p>
        <ng-container *ngIf="assignment?.customerDepartment">
          <span class="fw-medium">{{ assignment.customerDepartment.name }}</span
          ><br />
          {{ assignment.customerDepartment.businessAddress.street }}<br />
          {{ assignment.customerDepartment.businessAddress.postCode }}
          {{ assignment.customerDepartment.businessAddress.city }}
        </ng-container>
        <p class="fw-bold mt-4 mb-2">{{ 'externalEmployees.operationInfo.contactPerson' | translate }}</p>
        <p class="fw-bold mb-0">{{ 'name' | translate }}</p>
        <span
          class="mb-2"
          *ngIf="assignment?.responsibleCustomerUser"
          >{{ assignment.responsibleCustomerUser?.firstName }} {{ assignment.responsibleCustomerUser?.lastName }}</span
        >
        <ng-container *ngIf="assignment?.responsibleCustomerUser?.mobilePhone">
          <p class="fw-bold mb-0 mt-2">{{ 'externalEmployees.operationInfo.phone' | translate }}</p>
          <span>{{ assignment.responsibleCustomerUser?.mobilePhone }}</span>
        </ng-container>
        <ng-container *ngIf="assignment?.responsibleCustomerUser?.email">
          <p class="fw-bold mb-0 mt-2">{{ 'email' | translate }}</p>
          <span>{{ assignment.responsibleCustomerUser?.email }}</span>
        </ng-container>
      </div>
      <div>
        <h2 class="headline-24 mb-4">{{ 'provider' | translate }}</h2>
        <div
          class="d-flex flex-column"
          *ngIf="assignment?.pspBranch"
        >
          <span>{{ assignment.pspBranch.legalName }}</span>
          <span>{{ assignment.pspBranch.businessAddress.street }}</span>
          <span
            >{{ assignment.pspBranch.businessAddress.postCode }} {{ assignment.pspBranch.businessAddress.city }}</span
          >
          <div class="d-flex flex-row align-items-center gap-2 mt-2">
            <base-izs-rating
              [color]="assignment.pspBranch.izsStatus"
              (click)="openIzsInfoModal($event)"
            ></base-izs-rating>
            <p class="m-0 fw-bold">{{ 'izs.rating' | translate }}</p>
          </div>
        </div>
        <p class="fw-bold mb-0 mt-2">{{ 'contactPerson' | translate }}</p>
        <p class="fw-bold mb-0 mt-2">{{ 'name' | translate }}</p>
        <span *ngIf="assignment?.responsiblePspUser"
          >{{ assignment.responsiblePspUser?.firstName }} {{ assignment.responsiblePspUser?.lastName }}</span
        >
        <ng-container *ngIf="assignment?.responsiblePspUser?.mobilePhone">
          <p class="fw-bold mb-0 mt-2">{{ 'externalEmployees.operationInfo.phone' | translate }}</p>
          <span>{{ assignment.responsiblePspUser?.mobilePhone }}</span>
        </ng-container>
        <ng-container *ngIf="assignment?.responsiblePspUser?.email">
          <p class="fw-bold mb-0 mt-2">{{ 'email' | translate }}</p>
          <span>{{ assignment.responsiblePspUser?.email }}</span>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #documentViewerTemplate>
  <base-contract-viewer
    [src]="contractFile?.data || ''"
    [fileName]="contractFile?.fileName"
    [modalRef]="documentViewerModalRef"
  ></base-contract-viewer>
</ng-template>
